import { useEffect, useState } from 'react';
import Client from '../contexts/Client';
import { usePopupNotification } from '../selectors/selectors';
import {
  getLoginSessionId,
  isPopupNotificationSeen,
  markPopupNotificationSeen,
} from '../utils/popupNotification';

/**
 * Decides whether the popup notification has to be shown.
 *
 * The dismissal is tied to the auth token, so the notification is shown once per
 * login: it stays closed for the rest of the week - across reloads and new tabs -
 * and comes back once the weekly logout hands the user a fresh token.
 */
export const usePopupNotificationModal = () => {
  const token = Client.getToken();
  const loginSessionId = token ? getLoginSessionId(token) : '';
  // assume dismissed until we checked the storage, so the modal never flashes open
  const [isDismissed, setIsDismissed] = useState(true);

  useEffect(() => {
    setIsDismissed(!token || isPopupNotificationSeen(token));
  }, [token]);

  const { data: notification } = usePopupNotification(loginSessionId, !isDismissed);

  const close = () => {
    if (token) {
      markPopupNotificationSeen(token);
    }
    setIsDismissed(true);
  };

  return {
    notification: notification ?? null,
    isOpen: !isDismissed && Boolean(notification),
    close,
  };
};
